import React, { useState, useEffect, ReactNode, useMemo } from 'react';

import { branding } from '../../config/enum';

import ThemeContext, { initialThemeState } from './ThemeContext';

interface ThemeProviderProperties {
  children: ReactNode;
}

/**
 * Component handles App theme (dark & light)
 */
export function ThemeProvider({ children }: ThemeProviderProperties) {
  const currentBranding: string = process.env.REACT_APP_BRANDING || branding.ENERGIC;
  const [theme, setTheme] = useState<string>(initialThemeState.theme);

  const localStorage = window?.localStorage;

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('globalTheme', theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.setAttribute('data-branding', currentBranding);
  }, []);

  // Use useMemo to memoize the context value
  const value = useMemo(() => ({ theme, setTheme }), [theme]);

  return (
    <ThemeContext.Provider value={value}>
      <div className={`theme--${theme}`}>{children}</div>
    </ThemeContext.Provider>
  );
}

export default ThemeProvider;
